import Header from "./components/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import BasePriceTable from "./components/BasePriceTable";
import SlotPriceTable from "./components/SlotPriceTable";
import NotificationScreen from "./components/NotificationScreen";
import CricketCalenderView from "./components/CricketCalenderView";
import SlotBooking from "./components/SlotBooking";
import PrivateComponent from "./components/PrivateComponent";
import AdminLogin from "./components/AdminLogin";
import Home from "./components/Home";
import Dashboard from "./components/Dashboard";
import NotificationHistory from "./components/NotificationHistory";
import ClubMagazine from "./components/ClubMagazine";
import MemberPayment from "./components/MemberPayment";
import BillList from "./components/BillList";
import ContactUs from "./components/ContactUs";
import Events from "./components/Events";
import UpcomingEvents from "./components/UpcomingEvents";
import ActivityLogs from "./components/ActivityLogs";
import TestPayment from "./pages/test-payment";
import Payment from "./pages/payment";
import PaymentSuccess from "./pages/payment-status"
import ClubMagazineAdmin from "./components/ClubMagazineAdmin";
import PaymentRefund from "./pages/paymentRefund";
import ContactUsAdmin from "./components/ContactUsAdmin";
import PickleBallCalendarView from "./components/PickleBallCalendarView";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/test-payment" element={<TestPayment />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/paymentRefund" element={<PaymentRefund />} />
        <Route path="/payment-status" element={<PaymentSuccess />} />
        <Route path="/admin/basePrice" element={<PrivateComponent element={<BasePriceTable />} />} />
        <Route path="/admin/slotPrice" element={<PrivateComponent element={<SlotPriceTable />} />} />
        <Route path="/admin/notification" element={<PrivateComponent element={<NotificationScreen />} />} />
        <Route path="/admin/cricket-calender" element={<PrivateComponent element={<CricketCalenderView />} />} />
        <Route path="/admin/pickle-ball-calender" element={<PrivateComponent element={<PickleBallCalendarView />} />} />
        <Route path="/admin/slotBooking" element={<PrivateComponent element={<SlotBooking />} />} />
        <Route path="/admin/notification-history" element={<PrivateComponent element={<NotificationHistory />} />} />
        <Route path="/admin/club-magazine" element={<PrivateComponent element={<ClubMagazineAdmin />} />} />
        <Route path="/admin/contact-us" element={<PrivateComponent element={<ContactUsAdmin />} />} />
        <Route path="/admin/events" element={<PrivateComponent element={<Events />} />} />
        <Route path="/admin/activity" element={<PrivateComponent element={<ActivityLogs />} />} />
        
        <Route path="/club-magazine" element={<ClubMagazine />} />
        <Route path="/bill-list" element={<BillList />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<PrivateComponent element={<Dashboard />} />} />
        <Route path="/admin" element={<Home />} />
        {/* <Route path="/" element={<Header />} /> */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/upcomingEvents" element={<UpcomingEvents />} />
        <Route path="/" element={<MemberPayment />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
